<template>
  <v-row>
    <v-col sm="4" cols="12" :class="{ 'indicator-wrapper_first': inOneRow }">
      <indicator-item
        title="Принято заказов"
        :main-value="formatCount(indicators.acceptedOrdersCount)"
        main-value-color="#6BAD01"
        tooltip-text="Кол-во поступивших заказов в систему и кол-во обработанных заказов в КЦ"
        icon="/img/stat/icons/bag.svg"
        :loading="loading"
      >
        <template #sub-value>
          <span style="font-weight: bold">
            {{ formatCount(indicators.receivedOrdersCount) }} поступило
          </span>
        </template>
      </indicator-item>
    </v-col>
    <v-col sm="4" cols="12" :class="{ 'indicator-wrapper': inOneRow }">
      <indicator-item
        title="Выручка"
        tooltip-text="Выручка по заказам за период и сумма допродажи"
        :main-value="$options.filters.amountWithCurrency0(indicators.revenue)"
        icon="/img/stat/icons/receipt.svg"
        :loading="loading"
      >
        <template #sub-value>
          <div class="sub-value-label">
            допродажи:
          </div>
          <div class="sub-value-value" style="color: #ff9d00">
            {{ indicators.upsellingRevenue | amountWithCurrency0 }}
          </div>
        </template>
      </indicator-item>
    </v-col>
    <v-col sm="4" cols="12" :class="{ 'indicator-wrapper': inOneRow }">
      <indicator-item
        title="Отмены"
        tooltip-text="Кол-во отмененных заказов на этапе подтверждения КЦ"
        :main-value="formatCount(indicators.canceledOrdersCount)"
        main-value-color="#e92663"
        icon="/img/stat/icons/close.svg"
        :loading="loading"
      >
        <template #sub-value>
          <div class="sub-value-label">
            конверсия:
          </div>
          <div class="sub-value-value" style="color: #e92663">
            {{ indicators.canceledOrdersConversion }}%
          </div>
        </template>
      </indicator-item>
    </v-col>
    <v-col sm="4" cols="12" :class="{ 'indicator-wrapper': inOneRow }">
      <indicator-item
        title="Допродажи"
        tooltip-text="Кол-во допродаж по заказам и их конверсия от общего количества поступивших"
        :main-value="formatCount(indicators.upsellsOrdersCount)"
        main-value-color="#ff9d00"
        icon="/img/stat/icons/upsells.svg"
        :loading="loading"
      >
        <template #sub-value>
          <div class="sub-value-label">
            конверсия:
          </div>
          <div class="sub-value-value" style="color: #ff9d00">
            {{ indicators.upsellsOrdersConversion }}%
          </div>
        </template>
      </indicator-item>
    </v-col>
    <v-col sm="4" cols="12" :class="{ 'indicator-wrapper': inOneRow }">
      <indicator-item
        title="Время подтверждения"
        tooltip-text="Среднее время подтверждения заказа"
        :main-value="formattedSVPValue"
        :main-value-color="svpValueColor"
        icon="/img/stat/icons/svp.svg"
        hide-sub-value
        :loading="loading"
      >
      </indicator-item>
    </v-col>
  </v-row>
</template>

<script>
  import IndicatorItem from '../IndicatorItem.vue'
  import { formatNumberToThousandths } from '@/util/num-format'

  export default {
    name: 'FilialsIndicatorsList',
    components: { IndicatorItem },
    props: {
      indicators: {
        type: Object,
        default: () => {},
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        windowWidth: window.innerWidth,
      }
    },
    computed: {
      inOneRow () {
        return this.windowWidth >= 1200
      },
      formattedSVPValue () {
        const minutes = Math.floor(this.indicators.avgConfirmTime / 60)
        const seconds = this.indicators.avgConfirmTime % 60

        return `${minutes} мин ${seconds} сек`
      },
      svpValueColor () {
        return this.indicators.avgConfirmTime > 180 ? '#ff9d00' : '#6BAD01'
      },
    },
    created () {
      window.addEventListener('resize', this.setWindowWidth)
    },
    destroyed () {
      window.removeEventListener('resize', this.setWindowWidth)
    },
    methods: {
      formatCount (value) {
        return formatNumberToThousandths(value)
      },
      setWindowWidth () {
        this.windowWidth = window.innerWidth
      },
    },
  }
</script>

<style lang="less" scoped>
.sub-value-label {
  font-size: 12px;
  color: #949191;
}
.sub-value-value {
  font-size: 12px;
}
.indicator-wrapper {
  max-width: 20%;

  @media (max-width: 1200px) {
    max-width: revert;
  }

  &_first {
    max-width: 20%;

    @media (max-width: 1200px) {
      max-width: revert;
    }
  }
}
</style>
